export function navDrawer() {
    const menu = document.getElementById('menu');
    const toggle = document.getElementById('menu-button');
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute#Polyfill
    if (!Element.prototype.toggleAttribute) {
        Element.prototype.toggleAttribute = function(name, force) {
            if (force !== void 0) force = !!force;
            if (this.getAttribute(name) !== null) {
                if (force) return true;
                this.removeAttribute(name);
                return false;
            } else {
                if (force === false) return false;
                this.setAttribute(name, '');
                return true;
            }
        };
    }



    console.log('--------------------');
    // console.log(getCookie('devcookie'));
    // console.log(Cookies.get('devcookie'));
    console.log('--------------------');



    // toggle.addEventListener('click', () => {
    //     menu.toggleAttribute('aria-expanded');
    //     toggle.toggleAttribute('aria-expanded');
    // });

    //SIMON: added android check on resize
    // window.addEventListener('resize', () => {
    //     if ((getMobileOperatingSystem()) != 'Android') {
    //         menu.removeAttribute('aria-expanded');
    //         toggle.removeAttribute('aria-expanded');
    //     }
    // });

    //SIMON: added android check on resize
    window.addEventListener('resize', () => {
        $windowWidth = $(window).width();

        if ($('.ais-SearchBox-input').attr("placeholder") == "Search ..." && $('.ais-SearchBox-input').val() == "") {
            // console.log('VAA ' + $('.ais-SearchBox-input').val());

            // if ($windowWidth >= 1024) {
            //     // $('.ais-SearchBox-input').value = '1200';
            //     $('.ais-SearchBox-input').attr("placeholder", "Search ...");
            //     console.log('1200');
            // } else {
            //     // $('.ais-SearchBox-input').value = 'nnot';
            //     $('.ais-SearchBox-input').attr("placeholder", "");
            //     console.log('not 1200');
            // }


        }

        if ($windowWidth >= 1024) {
            // $('.ais-SearchBox-input').value = '1200';
            $('.ais-SearchBox-input').attr("placeholder", "Search ...");
            console.log('1200');
        } else {
            // $('.ais-SearchBox-input').value = 'nnot';
            $('.ais-SearchBox-input').attr("placeholder", "");
            console.log('not 1200');
        }
        // if ($windowWidth >= 1200) {
        //     $('.ais-SearchBox-input').value = '1200';
        //     $('.ais-SearchBox-input').attr("placeholder", "1200");
        //     console.log('1200');
        // } else {
        //     $('.ais-SearchBox-input').value = 'nnot';
        //     $('.ais-SearchBox-input').attr("placeholder", "not");
        //     console.log('not 1200');
        // }


    });

    /**
     * Determine the mobile operating system.
     * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
     *
     * @returns {String}
     */
    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
        return "unknown";
    }

}

// HACK FOR SHARE PRINT JS ASYNC ERROR
// function printPage() {
//     window.print();
// }

// function getCookie(sname) {
//     if (document.cookie.length != 0) {
//         var array = document.cookie.split("=");
//         console.log("Name=" + array[0] + " " + "Value=" + array[1]);
//     } else {
//         console.log("Cookie not available");
//     }
// }

// function getCookie(name) {
//     var re = new RegExp(name + "=([^;]+)");
//     var value = re.exec(document.cookie);
//     return (value != null) ? unescape(value[1]) : null;
// }



document.addEventListener('DOMContentLoaded', () => {


    $windowWidth = $(window).width();
    if ($windowWidth >= 1024) {
        // $('.ais-SearchBox-input').value = '1200';
        $('.ais-SearchBox-input').attr("placeholder", "Search ...");
        console.log('1200');
    } else {
        // $('.ais-SearchBox-input').value = 'nnot';
        $('.ais-SearchBox-input').attr("placeholder", "");
        console.log('not 1200');
    }

    // Unix timestamp (in seconds) to count down to
    // var twoDaysFromNow = (new Date().getTime() / 1000) + (86400 * 2) + 1;
    // var twoDaysFromNow = (new Date(1978378719).getTime()) + (1) + 1;
    // var twoDaysFromNow = (new Date(1695046641).getTime()) + (1) + 1;
    // Fri, 22 May 2023 09:29:03 GMT

    // Set up FlipDown
    /*
    var flipdown = new FlipDown(twoDaysFromNow).start()

    // Do something when the countdown ends
    .ifEnded(() => {
        console.log('The countdown has ended!');
    });
    */

    // Toggle theme
    //   var interval = setInterval(() => {
    //     let body = document.body;
    //     body.classList.toggle('light-theme');
    //     body.querySelector('#flipdown').classList.toggle('flipdown__theme-dark');
    //     body.querySelector('#flipdown').classList.toggle('flipdown__theme-light');
    //   }, 5000);


    /*
    let body = document.body;
    body.classList.toggle('light-theme');
    // // body.querySelector('#flipdown').classList.toggle('flipdown__theme-dark');
    // body.querySelector('#flipdown').classList.toggle('flipdown__theme-light');
    body.querySelector('#flipdown').classList.toggle('flipdown__theme-light');
    */


    // var ver = document.getElementById('ver');
    // ver.innerHTML = flipdown.version;



    // var tickercode = " <div class='tickerwrapper'><div class='countholder'><div class='countcontainer'><div class='box'><!-- 				<h3 id='alerttxt'></h3> --><h1 id='alerttxt2'> </h1></div><div class='box'><h3 id='daystxt'>Days</h3><h1 id='days'>0</h1></div><div class='box'><h3 id='hourstxt'>Hours</h3><h1 id='hours'>00</h1></div><div class='box'><h3 id='minutestxt'>Mins</h3><h1 id='minutes'>00</h1></div><div class='box'><h3 id='secondstxt'>Sec</h3><h1 id='seconds'>00</h1></div></div></div> <!-- div class='flipholder'><div id='flipdown' class='flipdown fpholder'></div></div --></div>";
    // var tickercode = "<div class='tickerwrapper'><div class='countholder'><div class='countcontainer'><div class='box'><!-- 				<h3 id='alerttxt'></h3> --><h1 id='alerttxt2'>Enter Now! Our Dessert Contest Ends In .. 	</h1></div><div class='box'><h3 id='daystxt'>Days</h3><h1 id='days'>0</h1></div><div class='box'><h3 id='hourstxt'>Hours</h3><h1 id='hours'>00</h1></div><div class='box'><h3 id='minutestxt'>Mins</h3><h1 id='minutes'>00</h1></div><div class='box'><h3 id='secondstxt'>Sec</h3><h1 id='seconds'>00</h1></div></div></div> <!-- div class='flipholder'><div id='flipdown' class='flipdown fpholder'></div></div --></div>";

    // $(".tickercontainer").html(tickercode);

    /*

        const finaleDate = new Date("June 10, 2023 00:00:00").getTime();

        const timer = () => {
            const now = new Date().getTime();
            let diff = finaleDate - now;
            if (diff < 0) {
                document.querySelector('.alert').style.display = 'block';
                document.querySelector('.countcontainer').style.display = 'none';
            }

            let days = Math.floor(diff / (1000 * 60 * 60 * 24));
            let hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
            let minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
            let seconds = Math.floor(diff % (1000 * 60) / 1000);

            days <= 99 ? days = `${days}` : days;
            days <= 9 ? days = `${days}` : days;
            hours <= 9 ? hours = `0${hours}` : hours;
            minutes <= 9 ? minutes = `0${minutes}` : minutes;
            seconds <= 9 ? seconds = `0${seconds}` : seconds;

            document.querySelector('#days').textContent = days;
            document.querySelector('#hours').textContent = hours;
            document.querySelector('#minutes').textContent = minutes;
            document.querySelector('#seconds').textContent = seconds;

        }
        timer();
        setInterval(timer, 1000);

    */

    // $windowWidth = $(window).width();
    // if ($windowWidth >= 1200) {
    //     $('.ais-SearchBox-input').value = '1200';
    //     console.log('1200');
    // } else {
    //     $('.ais-SearchBox-input').value = 'nnot';
    //     console.log('not 1200');
    // }




    // var list = [{
    //         "name": "Mustermann",
    //         "vorname": "Maxi",
    //         "email": "Maxi.Mustermann@gmail.com"
    //     },
    //     {
    //         "name": "Mustermann",
    //         "vorname": "Maximilian",
    //         "email": "Maxi.Mustermann@gmail.com"
    //     },
    //     {
    //         "name": "Mustermann",
    //         "vorname": "Martin",
    //         "email": "Martin.Mustermann@gmail.com"
    //     },
    //     {
    //         "name": "Mustermann",
    //         "vorname": "Elke",
    //         "email": "Elke.Mustermann@gmail.com"
    //     }
    // ];

    // var list = [{
    //         "title": "Old Man's War",
    //         "author": {
    //             "name": "John Scalzi",
    //             "tags": [{
    //                 "value": "African, American, Asian, Australian, Austrian, British, Canadian, Caribbean, Central & South American, Chinese, Danish, Eastern European, Ethiopian, French, German, Greek, Hungarian, Indian, Indonesian, Irish, Italian, Japanese, Jewish, Korean, Mediterranean, Mexican, Middle Eastern, Moroccan, New England, New Zealand, Pennsylvania Dutch American, Polish, Portuguese, Russian, Scottish, Singaporean, Southern American, Southwestern American, Spanish, Swiss, Thai, Tiawanese, Turkish, Vietnamese"
    //             }]
    //         }
    //     },
    //     {
    //         "title": "The Lock Artist",
    //         "author": {
    //             "name": "Steve Hamilton",
    //             "tags": [{
    //                 "value": "appetizer, entree, breakfast, lunch, snack, dinner, dessert"
    //             }]
    //         }
    //     }
    // ];

    // var list = [{
    //         "Category": "Food",
    //         "Sub": {
    //             "name": "Newest Recipes",
    //             "tags": [{
    //                 "value": "new, recipes, trending"
    //             }]
    //         },
    //         "Sub": {
    //             "name": "Course",
    //             "tags": [{
    //                 "value": "appetizer, entree, breakfast, lunch, snack, dinner, dessert"
    //             }]
    //         },
    //         "Sub": {
    //             "name": "Cuisine",
    //             "tags": [{
    //                 "value": "African, American, Asian, Australian, Austrian, British, Canadian, Caribbean, Central & South American, Chinese, Danish, Eastern European, Ethiopian, French, German, Greek, Hungarian, Indian, Indonesian, Irish, Italian, Japanese, Jewish, Korean, Mediterranean, Mexican, Middle Eastern, Moroccan, New England, New Zealand, Pennsylvania Dutch American, Polish, Portuguese, Russian, Scottish, Singaporean, Southern American, Southwestern American, Spanish, Swiss, Thai, Tiawanese, Turkish, Vietnamese"
    //             }]
    //         }
    //     },
    //     {
    //         "Category": "Food1",
    //         "Sub": {
    //             "name": "Newest Recipes",
    //             "tags": [{
    //                 "value": "new, recipes, trending"
    //             }]
    //         },
    //         "Sub": {
    //             "name": "Course",
    //             "tags": [{
    //                 "value": "appetizer, entree, breakfast, lunch, snack, dinner, dessert"
    //             }]
    //         },
    //         "Sub": {
    //             "name": "Cuisine",
    //             "tags": [{
    //                 "value": "African, American, Asian, Australian, Austrian, British, Canadian, Caribbean, Central & South American, Chinese, Danish, Eastern European, Ethiopian, French, German, Greek, Hungarian, Indian, Indonesian, Irish, Italian, Japanese, Jewish, Korean, Mediterranean, Mexican, Middle Eastern, Moroccan, New England, New Zealand, Pennsylvania Dutch American, Polish, Portuguese, Russian, Scottish, Singaporean, Southern American, Southwestern American, Spanish, Swiss, Thai, Tiawanese, Turkish, Vietnamese"
    //             }]
    //         }
    //     }
    // ];

    /*
    var list = [{
            "title": "Food",
            "author": "Newest Recipes",
            "tags": ["new"]
        },
        {
            "title": "Food",
            "author": "Course",
            "tags": ["appetizer", "entree", "breakfast", "lunch", "snack", "dinner", "dessert"]
        },
        {
            "title": "Food",
            "author": "Cuisine",
            "tags": ["African", "American", "Asian", "Australian", "Austrian", "British", "Canadian", "Caribbean", "Central & South American", "Chinese", "Danish", "Eastern European", "Ethiopian", "French", "German", "Greek", "Hungarian", "Indian", "Indonesian", "Irish", "Italian", "Japanese", "Jewish", "Korean", "Mediterranean", "Mexican", "Middle Eastern", "Moroccan", "New England", "New Zealand", "Pennsylvania Dutch American", "Polish", "Portuguese", "Russian", "Scottish", "Singaporean", "Southern American", "Southwestern American", "Spanish", "Swiss", "Thai", "Tiawanese", "Turkish", "Vietnamese"]
        },
        // ---
        {
            "title": "Food",
            "author": "Diet",
            "tags": ["Diabetic", "Gluten - free", "Halal", "Hindu", "Kosher", "Low - calorie", "Low - fat", "Low - lactose", "Low - salt", "Vegan", "Vegetarian"]
        },
        {
            "title": "Food",
            "author": "Seasonal",
            "tags": ["Birthday", "Christmas", "Cinco de Mayo", "Easter", "Fourth of July", "Halloween", "Hanukkah", "New Year", "Passover", "Ramadan", "St.Patrick� s Day", "Thanksgiving", "Valentine� s Day "]
        },
        {
            "title": "Food",
            "author": "Allergens",
            "tags": ["Gluten", "Eggs", "Wheat", "Citrus", "Nuts", "Soy", "Corn", "Peanuts", "Poultry", "Wine", "Tree Nuts", "Shellfish", "Fish"]
        },

        {
            "title": "Food",
            "author": "Allergens",
            "tags": ["Gluten", "Eggs", "Wheat", "Citrus", "Nuts", "Soy", "Corn", "Peanuts", "Poultry", "Wine", "Tree Nuts", "Shellfish", "Fish"]
        },
        {
            "title": "Food",
            "author": "Allergens",
            "tags": ["Gluten", "Eggs", "Wheat", "Citrus", "Nuts", "Soy", "Corn", "Peanuts", "Poultry", "Wine", "Tree Nuts", "Shellfish", "Fish"]
        },
        {
            "title": "Food",
            "author": "Allergens",
            "tags": ["Gluten", "Eggs", "Wheat", "Citrus", "Nuts", "Soy", "Corn", "Peanuts", "Poultry", "Wine", "Tree Nuts", "Shellfish", "Fish"]
        },

        {
            "title": "Food",
            "author": "Tips & Tricks",
            "tags": ["tips", "tricks"]
        },
        {
            "title": "Food",
            "author": "Food News",
            "tags": ["news"]
        },
        {
            "title": "Food",
            "author": "Recalls",
            "tags": ["recalls"]
        },
        {
            "title": "Food",
            "author": "Video",
            "tags": ["video"]
        }
    ]
    */


    // var searchEle = document.querySelector(".searchfuse"),
    //     resultall = document.querySelector(".result"),
    //     resultdiv = document.querySelector(".resultdiv span");

    // var fuseres = document.querySelector(".fuseresult");
    // console.log(resultall);

    /*
    function doSearch() {
        var resultJSON = fuse.search(searchEle.value);
        resultall.value = JSON.stringify(resultJSON, null, 3);

        // console.log(resultall);
        // resultall.length = '';

        var obj = JSON.parse(resultall.value);

        console.log('lll ' + obj.length);
        console.log('rrr ' + resultall.length);

        if (obj.length == 0) {
            resultall.value = 'No Result Found';

            // fuseres.value = '';
        } else {
            // fuseres.value = '11';

        }


        if (obj[0] !== null) {
            console.log('null');

            // console.log(obj[0].item + ' -------00 -------- ' + obj[0].item.length);

            mainCat = obj[0].item.title;
            subCat = obj[0].item.author;
            // childCat = obj[0].item.tags;
            console.log('-------  1 --------');

            // childCat = obj[0].item.toString();
            childCat = obj[0].matches[0].value;
            // console.log(childCat);
            // console.table(childCat);


            singleObj = obj[0];
            // console.log(singleObj.length + ' ---------------');
            // console.log(childCat.length + ' ---------------');
            console.log(resultall.length + ' ------- 2 -------- ' + resultall.value.length);
            // resultall.value = mainCat + ' > ' + subCat + ' > ' + childCat;

            if (resultall.length !== "undefined" || obj.length > 0) {
                // resultall.value = resultall.length + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat;
                // resultall.value = resultall.length + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat;

                // resultall.value = 'home ' + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat;

                // resultdiv.text = 'home ' + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat;
                resultdiv.innerHTML = 'home ' + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat;

                console.log('home ' + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat);
            } else {
                resultall.value = '';
            }
            // resultall.value = '';

            // resultall.value = resultall.length + ' > ' + mainCat + ' > ' + subCat + ' > ' + childCat;

            // resultall.value = obj[0].item.title;
            // console.log(result.value);
            // console.table(singleObj);


            // Then, you can ask
            // for any of it properties:

            // var mm = obj.title;
            // console.log(obj[0].item.title);


        }




    }
    */


    /*
    var options = {
        // shouldSort: true,
        // matchAllTokens: true,
        // findAllMatches: true,
        // threshold: 0.4,
        // location: 0,
        // distance: 100,
        // maxPatternLength: 32,
        // minMatchCharLength: 1,

        isCaseSensitive: false,
        includeScore: true,
        shouldSort: false,
        // includeMatches: false,
        findAllMatches: false,
        minMatchCharLength: 1,
        // location: 0,
        threshold: 0.0,
        // distance: 100,
        // useExtendedSearch: false,
        // ignoreLocation: false,
        // ignoreFieldNorm: false,
        // fieldNormWeight: 1,


        includeMatches: true,
        // includeScore: false,
        // keys: ['Sub.tags.value']
        // keys: ["vorname", "nachname", "email"]
        // keys: ["Sub", "tags", "value"]
        // keys: ["title", "author ", "tags ", "value "]
        // keys: [
        //     ['author', 'tags', 'value']
        // ]
        keys: ['tags']
    };
    */

    // var fuse = new Fuse(list, options);

    // searchEle.addEventListener("input", doSearch);

    // doSearch();


    //console.log('end');
});



// USED FOR THE RC CONTEST LIGHTBOX/SLIDESHOW
jQuery(function($) {
    // $("form input").click(function() {
    //     // alert('search');
    // });

    // $('.tickerwrapper').hover(function() {
    //     document.location.href = '/recipe-contest/';
    // });
    // $('.tickerwrapper').click(function() {
    //     document.location.href = '/recipe-contest/';
    // });

    // $("#pc_photo-name").click(function() {
    //     // alert('image_id1 + image_id2 ' + $image_id + ' -- ' + $image_id2);
    //     // alert('search');
    //     // alert('search');
    // });


    if ($("body").is("[contest-page='contest-share']")) {
        // alert('SHARE');
        setTimeout(function() {
            $('.confetti').remove();
            // console.log('confetti');
        }, 5000);
    }

    if ($("body").is("[page-type='contest']")) {
        /*success*/
        // alert('ss');
        $('.rc-slideshow').slick({
            dots: false,
            arrows: false,
            autoplay: true,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 6000,
            fade: true,
            cssEase: 'linear'
        });

        if ($('.confetti-piece').css('hidden') == true) {
            $('.confetti').remove();
            // alert('lll');
        }

        $('.confetti-piece').on('animationend webkitAnimationEnd', function() {
            // alert('end');

            setTimeout(function() {
                // $('.confetti').remove();
                // console.log('confetti');
            }, 5000);

        });



        $("#stop").click(function() {
            $("#animated").addClass("off");
        });
        $("#start").click(function() {
            $("#animated").removeClass("off");
        });

    } else {
        /*does not have*/
        // alert('nn');
    }



    if ($("body").is("[page-type='contest']")) {
        /*success*/
        // alert('ss');

        // if ($('.confetti-piece').finish())




        // alert('lol');



    } else {
        /*does not have*/
        // alert('nn');
    }




    // Responsive burger menu
    $('[data-target="navbar-menu-toggle"]').click(function() {
        // $('.navbar-dd').children().removeClass("is-active");
        // console.log('remove');
        let navbarMenu = $(".navbar-menu");
        if (!navbarMenu.hasClass("is-active")) {

            // $(this).find(".searchEl")
            // $('.navbar-dd').removeClass("is-active");
            // $('.navbar-dd').children().removeClass("is-active");

            navbarMenu.addClass("is-active");
            $(this).addClass("is-active");

            $('.navsub').addClass("is-active");

            // $(this).children(".navbar-dropdown").addClass("is-active");
            // $(".parent").find(".searchEl")
            // alert('ns');

        } else {
            navbarMenu.removeClass("is-active");
            $(this).removeClass("is-active");

            $('.navsub').removeClass("is-active");
            // alert('ns');
        }
    });

    // Responsive dropdown menu item combined with css display
    $(".navbar-item").click(function() {
        // $('.navbar-dd').children().removeClass("is-active");
        // console.log('remove');

        if ($(this).hasClass("has-dropdown")) {
            $(this).toggleClass("is-active");
        } else {
            $('.navbar-menu, [data-target="navbar-menu-toggle"]').removeClass("is-active");
        }
    });





    // wp_enqueue_script('fassj', 'https://kit.fontawesome.com/9213a21814.js');


    // wp_enqueue_script('fusejs', 'https://cdn.jsdelivr.net/npm/fuse.js/dist/fuse.js');
    // var list = [{
    //         "name": "Mustermann",
    //         "vorname": "Maxi",
    //         "email": "Maxi.Mustermann@gmail.com"
    //     },
    //     {
    //         "name": "Mustermann",
    //         "vorname": "Maximilian",
    //         "email": "Maxi.Mustermann@gmail.com"
    //     },
    //     {
    //         "name": "Mustermann",
    //         "vorname": "Martin",
    //         "email": "Martin.Mustermann@gmail.com"
    //     },
    //     {
    //         "name": "Mustermann",
    //         "vorname": "Elke",
    //         "email": "Elke.Mustermann@gmail.com"
    //     }
    // ];



});




// var form = document.getElementById("formsearch");

// document.getElementById("iconsub").addEventListener("click", function() {
//     var nameInput = document.querySelector(".ais-SearchBox-input");
//     document.location.href = '/?s=' + nameInput.value;

//     // alert('search ' + nameInput.value);
//     // testResults(this.form);
//     // form.submit();
// });

const ENTER_BUTTON_KEY_CODE = 13;

document.addEventListener('keyup', event => {
    if (event.keyCode === ENTER_BUTTON_KEY_CODE) {
        // console.log('Enter was pressed. Yay!');
        var nameInput = document.querySelector(".ais-SearchBox-input");
        document.location.href = '/?s=' + nameInput.value;

    } else {
        // console.error(`${event.code} was pressed.`);
    }
});

// function testResults(form) {
//     var inputValue = form.inputbox.value;
//     alert("You typed: " + inputValue);
// }



